/**
 * Chummys delivered — <chummys-map>
 * The animations live in CSS. This says when: `is-in` once the band is on
 * screen (the deliveries land), `is-running` while it stays there (the
 * postmarks drift), so nothing animates off-screen.
 */
(() => {
  if (customElements.get('chummys-map')) return;
  class ChummysMap extends HTMLElement {
    connectedCallback() {
      this.io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) { this.classList.add('is-in', 'is-running'); }
          else this.classList.remove('is-running');
        }
      }, { threshold: 0.15 });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }
  customElements.define('chummys-map', ChummysMap);
})();
